import { useFeatureFlag } from 'v2/core/clients/featureFlag';
import { FeatureFlagType } from 'v2/core/clients/featureFlag/flags';

const realtimeReportingFeatureFlag: FeatureFlagType = {
  name: 'realtime_frequency',
  fallback: false,
};

export const useIsRealtimeReportingEnabled = () => {
  const [, isRealtimeReportingEnabled] = useFeatureFlag(
    realtimeReportingFeatureFlag,
  );

  return isRealtimeReportingEnabled;
};
